import type {
  AnalyticsProvider,
  EventProperties,
  UserProperties,
} from '../types'

import '@/integrations/gtm/types'

export class GTMDataLayerProvider implements AnalyticsProvider {
  name = 'gtm'

  private push(data: Record<string, unknown>): void {
    if (window.dataLayer) {
      window.dataLayer.push(data)
    }
  }

  track(eventName: string, properties?: EventProperties): void {
    this.push({ event: eventName, event_properties: properties })
  }

  identify(userId: string): void {
    this.push({ event: 'user_identified', user_id: userId })
  }

  alias(newId: string, previousId?: string): void {
    this.push({
      event: 'user_aliased',
      user_id: newId,
      previous_user_id: previousId,
    })
  }

  setUserProperties(properties: UserProperties): void {
    this.push({ event: 'user_properties_set', user_properties: properties })
  }

  reset(): void {
    this.push({ event: 'user_reset' })
  }
}
